/**
 * Section 3 of 4. The path is `/invites` and the heading is `Invite`.
 *
 * GLOSSARY-18 bans "Invites" as a fan-visible tab label, not as a URL
 * segment. A route path is a fixed English string and is not fan-facing
 * copy. The web path is /invites, labeled Invite everywhere a fan reads
 * it. ISSUE-324 R1 says `/invite` and is wrong.
 *
 * ISSUE-481 fills this section in: the list pane plus the `?inviteId=`
 * preview dialog.
 */
import {
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import type { ReactNode } from "react";

import { requireSignedIn } from "../auth/requireSignedIn";
import { InvitePreviewDialog } from "../features/invites/InvitePreviewDialog";
import { InvitesListPane } from "../features/invites/InvitesListPane";
import { validateInvitesSearch } from "../routeState/sectionSearch";
import { SectionScreen } from "../shell/SectionScreen";

const InvitesScreen = (): ReactNode => {
  const search = useSearch({ from: "/invites" });
  const navigate = useNavigate({ from: "/invites" });

  return (
    <SectionScreen heading="Invite">
      <InvitesListPane
        onOpenInvite={(inviteId) => {
          void navigate({ search: (prev) => ({ ...prev, inviteId }) });
        }}
      />
      <InvitePreviewDialog
        inviteId={search.inviteId}
        onClose={() => {
          void navigate({
            search: (prev) => ({ ...prev, inviteId: undefined }),
            replace: true,
          });
        }}
        onGoToPool={(poolId) => {
          void navigate({ to: "/pools", search: { poolId } });
        }}
      />
    </SectionScreen>
  );
};

export const Route = createFileRoute("/invites")({
  beforeLoad: requireSignedIn,
  validateSearch: validateInvitesSearch,
  component: InvitesScreen,
});
